import {z} from 'zod';
import {FirestoreTimestampSchema} from '../types';

// ============================================================================
// Healthcheck Document Schemas
// ============================================================================

export const HealthcheckRequestSchema = z
  .object({
    service: z.string(),
    status: z.enum(['ok', 'error']),
    courseId: z.string().nullable(),
    metadata: z.record(z.string(), z.unknown()).nullable(),
    message: z.string().nullable(),
  })
  .loose();

export type HealthcheckRequest = z.infer<typeof HealthcheckRequestSchema>;

export const HealthcheckLogSchema = HealthcheckRequestSchema.extend({
  timestamp: FirestoreTimestampSchema,
}).loose();

export type HealthcheckLog = z.infer<typeof HealthcheckLogSchema>;

// ============================================================================
// Paths
// ============================================================================

export const HEALTHCHECK_COLLECTION = 'healthcheck' as const;

export function getHealthcheckCollectionPath(): string {
  return HEALTHCHECK_COLLECTION;
}

export function getHealthcheckDocumentPath({logId}: {logId: string}): string {
  return `${HEALTHCHECK_COLLECTION}/${logId}`;
}

// ============================================================================
// Callable Function Definitions
// ============================================================================

export const QUERY_HEALTHCHECK_LOGS_FUNCTION = 'queryhealthchecklogs' as const;

export const QueryWhereFilterConstraintSchema = z.object({
  fieldPath: z.string(),
  operator: z.string(),
  value: z.unknown(),
});

export const QueryOrderByConstraintSchema = z.object({
  fieldPath: z.string(),
  direction: z.enum(['asc', 'desc']).optional(),
});

export const QueryHealthcheckLogRequestSchema = z.object({
  whereClauses: z.array(QueryWhereFilterConstraintSchema),
  orderByClauses: z.array(QueryOrderByConstraintSchema),
  limit: z.number().optional(),
  startAfter: z.array(z.unknown()).optional(),
});

export type QueryHealthcheckLogRequest = z.infer<
  typeof QueryHealthcheckLogRequestSchema
>;

export const QueryHealthcheckLogResponseSchema = z.object({
  logs: z.array(HealthcheckLogSchema).nullable(),
});

export type QueryHealthcheckLogResponse = z.infer<
  typeof QueryHealthcheckLogResponseSchema
>;
